import { useEffect, useState } from 'react';

const ContactFormOverlay = ({ isVisible = false, onAccept, onDecline }) => {
    const [visible, setVisible] = useState(isVisible);

    useEffect(() => {
        setVisible(isVisible);
    }, [isVisible]);

    const message = "Möchten Sie Ihr Fahrzeug als <span>Speichererweiterung</span> nutzen?";
    const submitBtnText = "Jetzt anfragen";
    const abortBtnText = "Kein Interesse";
    const additionalInfosBtn = "Weitere Infos";
    const edsnSrc = process.env.REACT_APP_ASSET_PATH + '/images/edsn.png';
    const edsnSrcSet = process.env.REACT_APP_ASSET_PATH + '/images/edsn-x2.png 1x,' + process.env.REACT_APP_ASSET_PATH + '/images/edsn-x2.png 2x';
    const title = "Möchten Sie Ihr Fahrzeug als <span>Speichererweiterung</span> nutzen?";

    const onAbort = () => {
        if (onDecline) {
            onDecline();
        }
        setVisible(false);
    }

    const onSubmit = () => {
        if (onAccept) {
            onAccept();
        }
        setVisible(false);
    }

    const onAdditionalInfos = () => {
        window.open('/bidirektionales-laden/', '_blank', 'noopener,noreferrer');
    }

    if (!visible) return null;

    return (
        <div className="contact-form-overlay">
            <div className="contact-form-popup-content">
                <div className="contact-form-inner">
                    <div className="d-flex flex-column align-items-center">
                        <div className="contact-form-title">
                            Möchten Sie Ihr Fahrzeug als <span>Speichererweiterung</span> nutzen?
                            <div className="contact-form-subtitle">
                                Jetzt mit der bidirektionalen Ladestation edsn von E3/DC
                            </div>
                        </div>
                        <div className="contact-form-body">
                            <div className="contact-form-image">
                                <img
                                    src={edsnSrc}
                                    srcSet={edsnSrcSet}
                                    alt="Produkt edsn"
                                />
                            </div>
                            <div className="contact-form-text">
                                {/* <p>{message}</p> */}
                                <button
                                    className="contact-form-button"
                                    onClick={onSubmit}
                                >
                                    {submitBtnText}
                                </button>
                                <button
                                    className="contact-form-button secondary"
                                    onClick={onAbort}
                                >
                                    {abortBtnText}
                                </button>
                                <div className="mt-2" style={{width: '100%', textAlign: 'center'}}>
                                <a
                                    href="/additional-info"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-form-link"
                                >
                                    {additionalInfosBtn}
                                </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactFormOverlay;
